import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import theme from 'style/theme';
import SonevoLoadingIndicator from 'shared/components/loading-indicator/sonevo-loader';
import { HistoryItemType } from 'shared/components/timeline/enums/history-item-type';

import { useHistoryContextProvider } from 'features/history/providers/history-provider';
import HistoryDetailsHeader from './history-details-header.component';
import HistoryDetailsLeftContent from './history-details-left-content.component';
import HistoryDetailsRightContent from './history-details-right-content.component';
import styles from './history-details.component.module.scss';

const HistoryDetails = (): ReactElement => {
  const { currentSelectedItem, setCurrentSelectedItem, isAlarmDataLoading, readAlarmError, readEmergencyAlarmError } =
    useHistoryContextProvider();

  const { t } = useTranslation('history');

  return (
    <Dialog
      open={currentSelectedItem !== undefined}
      onClose={() => setCurrentSelectedItem(undefined)}
      className={styles.historyDetails}
      slotProps={{
        paper: {
          className: styles.historyDetailsPaper,
        },
      }}
    >
      <HistoryDetailsHeader />
      <div className={styles.historyDetailsContent}>
        {readAlarmError || readEmergencyAlarmError ? (
          <Typography variant="caption" sx={{ color: theme.palette.error.main }}>
            {t('error')}
          </Typography>
        ) : (
          <>
            {!currentSelectedItem || (currentSelectedItem.historyType === HistoryItemType.Alarm && isAlarmDataLoading()) ? (
              <div className={styles.loadingIndicator}>
                <SonevoLoadingIndicator size={50} />
              </div>
            ) : (
              <>
                <div className={styles.historyDetailsLeftContent}>
                  <HistoryDetailsLeftContent />
                </div>
                <div className={styles.historyDetailsRightContent}>
                  <HistoryDetailsRightContent />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </Dialog>
  );
};

export default HistoryDetails;
